import * as firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'

import {
    PRODUCT_CREATE,
    PRODUCT_FETCH,
    PRODUCT_UPDATE,
    PRODUCT_PRICE_UPDATE
} from './types';

export const productDeleteById = (id, files, data) => {
    return (dispatch) => {
        firebase.database().ref('products/'+id).remove()
        .then(() => {
            firebase.database().ref('brands/'+data.brand_id+'/'+data.type).once('value', snapshot => { 
                let point = snapshot.val()-1
                firebase.database().ref('brands/'+data.brand_id).update({ [data.type]: point})
                .then(res => {
                    // ===Reorder Prouduct===
                    firebase.database().ref('products').orderByChild('brand_title').equalTo(data.brand_title).once('value', snapshot => {
                        let data2 = []
                        snapshot.forEach(childSnapshot => {
                            let item = childSnapshot.val()
                            if( typeof item === 'object' && item.type === data.type2) {
                                item.order = Number(item.order)
                                data2.push(item)
                            }
                        })
                        data2.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
                        let run = 1
                        data2.forEach((item) => {
                            if(item.type === data.type2) {
                                firebase.database().ref('products/'+item.id).update({ order: run })
                                run++
                            }
                        });
                        const redirect = `/admin/productdetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.type2}`
                        removeOldFile(files, redirect)
                    })
                    // ===Reorder Prouduct===
                })
                .catch(err => {
                    dispatch({ type: PRODUCT_CREATE, payload: false })
                })
            })
        })
    }
}

// const removeTwoOldFile = (files, redirect) => {
//     const ref = firebase.storage().ref().child(files.oldCatalog);
//     // Delete the file
//     ref.delete().then(() => {
//         const ref2 = firebase.storage().ref().child(files.oldPhoto);
//         ref2.delete().then(() => {
//             window.location = redirect
//         }).catch(error => window.location = redirect)
//     }).catch((error) => {
//         window.location = redirect
//     });
// }

const removeOldFile = (src, redirect) => {
    const ref = firebase.storage().ref().child(src);
    // Delete the file
    ref.delete().then(() => {
        window.location = redirect
    }).catch((error) => {
        window.location = redirect
    });
}

const productCheckOrder = (id, brand_title, order, oldOrder) => {
    return new Promise(resolve => {
        firebase.database().ref("/products/"+id).once('value', snapshot => {
            let type = snapshot.val().type
            firebase.database().ref('products').orderByChild('brand_title').equalTo(brand_title).once('value', snapshot => {
                let data = []
                snapshot.forEach(childSnapshot => {
                    let item = childSnapshot.val()
                    if( typeof item === 'object' && item.type === type) {
                        item.order = Number(item.order)
                        data.push(item)
                    }
                })
                data.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
                oldOrder = Number(oldOrder)
                order = Number(order)
                if(oldOrder > order) {
                    let run = Number(order)+1
                    data.forEach((item) => {
                        if(item.type === type) {
                            if(item.order < oldOrder && item.order >= order && item.id !== id) {
                                firebase.database().ref('products/'+item.id).update({ order: run })
                                run++
                            }
                        }
                    });
                    setTimeout(()=>resolve(true), 1000)
                } else if (oldOrder < order) {
                    let run = Number(oldOrder)
                    data.forEach((item) => {
                        if(item.type === type) {
                            if(item.order > oldOrder && item.order <= order && item.id !== id) {
                                firebase.database().ref('products/'+item.id).update({ order: run })
                                run++
                            }
                        }
                    });
                    setTimeout(()=>resolve(true), 1000)
                }
            })
        })
    })
}

export const productUpdate = (id, data, oldFiles, oldOrder) => {
    return (dispatch) => {
        dispatch({ type: PRODUCT_UPDATE, payload: true })
        const redirect = `/admin/productdetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.type}`
        if(data.img) {
            // Change both catalog and img
            const storage = firebase.storage().ref()
            // Upload Img
            const filename = Date.now()+"."+data.img.name.split('.').pop()
            const fileRef = storage.child('product/'+filename)
            fileRef.put(data.img).then(()=>{
                fileRef.getDownloadURL().then((url) => {
                    data.img = url
                    firebase.database().ref('products/'+id).update(data)
                    .then(async res => {
                        if(Number(data.order) !== Number(oldOrder)) {
                            const chk = await productCheckOrder(id, data.brand_title, data.order, oldOrder)
                            if (chk) {
                                removeOldFile(oldFiles, redirect)
                            }
                        } else {
                            removeOldFile(oldFiles, redirect)
                        }
                    })
                    .catch(err => {
                        dispatch({ type: PRODUCT_UPDATE, payload: false })
                    })
                })
            })
        } else if (data.img === "") {
            // No file change
            delete data.img
            // delete data.catalog
            firebase.database().ref('products/'+id).update(data)
            .then(async res => {
                if(Number(data.order) !== Number(oldOrder)) {
                    const chk = await productCheckOrder(id, data.brand_title, data.order, oldOrder)
                    if (chk) {
                        window.location = redirect
                    }
                } else {
                    window.location = redirect
                }
            })
            .catch(err => dispatch({ type: PRODUCT_UPDATE, payload: false }))
        }
    }
}

export const productUpdateInventory = (id, data, type) => {
    return (dispatch) => {
        firebase.database().ref('products/'+id).update(data)
        .then(async res => {
            window.location = `/admin/product-inventory?type=${type}`
        })
    }
}

export const productUpdatePrice = (id, data) => {
    return (dispatch) => {
        firebase.database().ref('products/'+id).update(data)
        .then(async res => {
            dispatch({ type: PRODUCT_PRICE_UPDATE, payload: { id, data } })
        })
    }
}

export const productFetchByInventory = (type = 'wall') => {
    return (dispatch) => {
        let	productsRef = firebase.database().ref('products').orderByChild('brand_title')
		productsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if (
                  item.type === type &&
                  (item.inventory === "" ||
                    item.inventory === "สินค้าขาด" ||
                    item.inventory === "ของขาด")
                ) {
                  data.push(item);
                }
            })
            // console.log('=> data', data)
			dispatch({ type: PRODUCT_FETCH, payload: data });
		})
    }
}

export const productFetchByType = (brand_title, type) => {
    return (dispatch) => {
        let	productsRef = firebase.database().ref('products').orderByChild('brand_title').equalTo(brand_title)
		productsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object' && item.type === type) {
                    item.order = Number(item.order)
                    data.push(item)
                }
            })
            data.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
			dispatch({ type: PRODUCT_FETCH, payload: data });
		})
    }
}

export const productFetchByTypeOrderByName = (brand_title, type) => {
    return (dispatch) => {
        let	productsRef = firebase.database().ref('products').orderByChild('brand_title').equalTo(brand_title)
		productsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object' && item.type === type) {
                    item.sort = item.title.replace(/[0-9]/g, '');
                    item.sort2 = item.title.match(/\d+/)[0]
                    data.push(item)
                }
            })
            data.sort((a,b) => (a.sort2 > b.sort2) ? 1 : ((b.sort2 > a.sort2) ? -1 : 0))
            data.sort((a,b) => (a.sort > b.sort) ? 1 : ((b.sort > a.sort) ? -1 : 0))
			dispatch({ type: PRODUCT_FETCH, payload: data });
		})
    }
}

export const productFetchById = (id) => {
    return (dispatch) => {
        let	productsRef = firebase.database().ref('products').child(id)
		productsRef.once('value', snapshot => {
            const data = snapshot.val()
            dispatch({ type: PRODUCT_FETCH, payload: [ data ] });
		})
    }
}

export const productFetch = (brand_title) => {
    return (dispatch) => {
        let	productsRef = firebase.database().ref('products').orderByChild('brand_title').equalTo(brand_title)
		productsRef.once('value', snapshot => {
			let data = []
			snapshot.forEach(childSnapshot => {
                let item = childSnapshot.val()
                if( typeof item === 'object') {
                    data.push(item)
                }
			})
			dispatch({ type: PRODUCT_FETCH, payload: data.reverse() });
		})
    }
}

export const productCreate = (data, type) => {
    return (dispatch) => {
        dispatch({ type: PRODUCT_CREATE, payload: true })
        const filename = Date.now()+"."+data.img.name.split('.').pop()
        const storage = firebase.storage().ref()
        const fileRef = storage.child('product/'+filename)
        fileRef.put(data.img).then(()=>{
            fileRef.getDownloadURL().then((url) => {
                data.img = url
                const productsRef = firebase.database().ref('products').push()
                const id = productsRef.key
                data.id = id
                productsRef.set(data)
                .then(response => {
                    firebase.database().ref('brands/'+data.brand_id+'/'+type).once('value', snapshot => { 
                        let point = snapshot.val()+1
                        firebase.database().ref('brands/'+data.brand_id).update({ [type]: point})
                        .then(res => {
                            // ===Reorder Prouduct===
                            firebase.database().ref('products').orderByChild('brand_title').equalTo(data.brand_title).once('value', snapshot => {
                                let data2 = []
                                snapshot.forEach(childSnapshot => {
                                    let item = childSnapshot.val()
                                    if( typeof item === 'object' && item.type === data.type) {
                                        item.order = Number(item.order)
                                        data2.push(item)
                                    }
                                })
                                data2.sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
                                data2.splice(data2.findIndex(e => e.id === data.id),1);
                                let run = 2
                                data2.forEach((item) => {
                                    if(item.type === data.type) {
                                        firebase.database().ref('products/'+item.id).update({ order: run })
                                        run++
                                    }
                                });
                                setTimeout(()=>window.location = `/admin/productdetail?id=${data.brand_id}&title=${data.brand_title}&type=${data.type}`, 1000)
                            })
                            // ===Reorder Prouduct===
                        })
                        .catch(err => {
                            dispatch({ type: PRODUCT_CREATE, payload: false })
                            console.log("productCreate", err)
                        })
                    })
                })
                .catch(err => {
                    console.log("productCreate", err)
                })
                    // })
                // })
            })
        })
    }
}